import { useEffect, useState } from 'react';

/**
 * Tracks match state of a media query.
 *
 * @param query Media query to parse.
 *
 * @returns `true` if the associated media query list matches the state of the [`document`](https://developer.mozilla.org/docs/Web/API/Document), or `false` otherwise.
 *
 * @example
 * function Component() {
 *   const isWidescreen = useMedia('(min-aspect-ratio: 16/9)');
 *   // ...
 * }
 */
export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mediaQueryList = matchMedia(query);

      function handleChange(): void {
        setMatches(mediaQueryList.matches);
      }

      mediaQueryList.addEventListener('change', handleChange);
      handleChange();

      return (): void => {
        mediaQueryList.removeEventListener('change', handleChange);
      };
    }

    return undefined;
  }, [query]);

  return matches;
}
